import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CONFIGURATION } from '../app.constants';
import { map } from 'rxjs/operators';
import { HttpHandler } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { error } from '@angular/compiler/src/util';
import { ErrorHandler } from '@angular/core';
import { throwError } from 'rxjs';

import { CreateModifyUser } from '../models';
declare var config: any;
@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }
    private userURL = CONFIGURATION.baseUrls.UserURL;
    // getAll() {
    //     return this.http.get<User[]>(`${config.apiUrl}/users`);
    // }
    getAllUsers(): Observable<any> {
        return this.http.get(this.userURL + 'user/GetAllUsers');

    }
    getAllUsersByRoleName(roleName): Observable<any> {
        const url = this.userURL + 'user/GetAllUsersByRoleName?roleName=' + roleName;
        return this.http.get(url);
       // return this.http.get(this.userURL + 'user/GetAllUsers');

    }
    getUserDetails(id): Observable<any> {
        const url = this.userURL + 'user/GetUserById?guid=' + id;
        return this.http.get(url);

    }
    getRoles(): Observable<any> {
        return this.http.get(this.userURL + 'user/GetAllRoles');
    }
    saveUser(body: CreateModifyUser): Observable<CreateModifyUser> {
        let httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: httpHeaders };
        const url = this.userURL + 'user/SaveUser';
        return this.http.post<CreateModifyUser>(url, body, options)
        // .pipe(catchError(this.handleServerError));


    }
    deleteUser(userGuid, userName): Observable<CreateModifyUser> {
        let httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: httpHeaders };
        const url = this.userURL + 'user/DeleteUser?userGuid=' + userGuid + '&userName=' + userName;
        return this.http.post<CreateModifyUser>(url, '', options)
        // .pipe(catchError(this.handleServerError));


    }
    ValidateUserName(userName):Observable<any> {
        return this.http.get(this.userURL + 'user/ValidateUserName?userName='+userName);
    }
}